export const NotFoundRoute = "/fehler";
